module.exports = __webpack_public_path__ + "img/Frame-17.58532339.svg";